var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      closeToggle();
      panel.style.display = "block";
    }
  });
}

function closeToggle()
{
  console.log('closeToggle');
  for (var j = 0; j < acc.length; j++) {
    var contents = acc[j].nextElementSibling;
    if (contents.style.display === "block") {
      acc[j].classList.remove("active");
      contents.classList.remove("active");
      contents.style.display = "none";
    } 
  }
}